import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useMenuModel } from './Sidebar';
import { toTiles } from './MegaMenu';
import { sectionFor } from './section-nav';
import { brand } from '../../shared/lib/brand';
import './section-nav.css';

/**
 * Строка навигации под шапкой R3 (просторная шапка, 03.11.2026):
 * логотип, «Главная» и «Сегодня» (если пилот включён), а внутри
 * раздела — его пункты: «Хаускипинг · Дашборд · Помещения…», чтобы
 * переходить внутри раздела, не открывая общее меню (запрос
 * 30.10.2026). Пункты те же, что в «Меню», с теми же правами и
 * флагами (useMenuModel).
 */
export const SectionNav = observer(function SectionNav() {
  const m = useMenuModel();
  const tiles = useMemo(() => toTiles(m.allMenuItems), [m.allMenuItems]);
  const path = m.location.pathname;
  const hit = sectionFor(tiles, path);
  const tile = hit ? tiles.find((t) => t.key === hit.tile.key) : null;
  const isOn = (k: string) => path === k || path.startsWith(`${k}/`);
  const inMenu = (k: string) => tiles.some((t) => t.key === k);
  // «Главная» — и когда сотрудник HKeeper смотрит отель без режима входа
  // (в его меню пункта нет, а страница открыта).
  const top = [
    { key: '/dashboard', label: 'Главная', show: inMenu('/dashboard') || isOn('/dashboard') },
    { key: '/ops/today', label: 'Сегодня', show: inMenu('/ops/today') },
  ].filter((t) => t.show);
  return (
    <nav className="r3-section-nav" aria-label="Навигация">
      <span className="r3-nav-brand">
        <img className="r3-nav-logo" src={brand.logo} alt="" />
        {brand.name}
      </span>
      {top.map((t) => (
        <button
          key={t.key}
          className={isOn(t.key) ? 'on' : ''}
          aria-current={isOn(t.key) ? 'page' : undefined}
          onClick={() => m.navigate(t.key)}
        >
          {t.label}
        </button>
      ))}
      {tile && hit && (
        <>
          <span className="r3-nav-sep" aria-hidden />
          <span className="r3-section-title">{tile.title}</span>
          {tile.links.map((l) => (
            <button
              key={l.key}
              className={l.key === hit.active ? 'on' : ''}
              aria-current={l.key === hit.active ? 'page' : undefined}
              onClick={() => m.navigate(l.key)}
            >
              {l.label}
            </button>
          ))}
        </>
      )}
    </nav>
  );
});
